import { render, staticRenderFns } from "./ProductList1.vue?vue&type=template&id=07595ce8&scoped=true&"
import script from "./ProductList1.vue?vue&type=script&lang=js&"
export * from "./ProductList1.vue?vue&type=script&lang=js&"
import style0 from "./ProductList1.vue?vue&type=style&index=0&id=07595ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07595ce8",
  null
  
)

export default component.exports